import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useContext } from "react";
import path from "path";
import useApi from "../../../api";
import config from "../../../config";
import PageNotFound from "../../errors/404"; // components

import { RouterHistoryContext } from "../../../components/BackButton";
import Masterplan from "../../../components/Masterplan";
import BackButton from "../../../components/BackButton";
var NB_SLUG = config.api.get("neighbourhood"),
    PROJECT_SLUG = config.api.get("project");
export var LandForSalePage = function LandForSalePage(a) {
  var b = a.showFilters,
      c = a.noAdvancedSearch,
      d = a.isResultPage,
      e = a.className,
      f = _objectWithoutProperties(a, ["showFilters", "noAdvancedSearch", "isResultPage", "className"]),
      g = useApi(),
      h = useContext(RouterHistoryContext),
      i = h.old,
      j = g.neighbourhoods.list(),
      k = f.match.params,
      l = k.neighbourhoodOrRelease,
      m = k.releaseOrLot,
      n = k.lotOrLotID,
      o = l ? l.toLowerCase() : null,
      p = m ? m.toLowerCase() : null,
      q = k.lotID ? k.lotID.toLowerCase() : null;

  NB_SLUG && (o = NB_SLUG, p = l ? l.toLowerCase() : null, q = n ? n.toLowerCase() : null);
  if (!PROJECT_SLUG && !NB_SLUG && !o) return /*#__PURE__*/React.createElement(PageNotFound, null);
  var r = i && "Results" === i.name,
      s = "",
      t = "";
  q && (!i || r) ? (s = "Results", t = config.routes.get("landforsale.results")) : (q ? (s = "Release", t = NB_SLUG ? "".concat(p) : "".concat(o, "/").concat(p)) : NB_SLUG ? s = "Masterplan" : p ? (s = config.labels.get("filters.neighbourhood"), t = "".concat(o)) : o && (s = "Masterplan", t = ""), t = path.join(config.routes.get("landforsale.masterplan"), t));
  var u = !NB_SLUG && o || NB_SLUG && p;
  return /*#__PURE__*/React.createElement(React.Fragment, null, u ? /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(BackButton, {
    title: s,
    to: t
  }))) : null, /*#__PURE__*/React.createElement(Masterplan, {
    className: e,
    navigation: !0,
    neighbourhoods: j,
    selectedNeighbourhood: o,
    selectedRelease: p,
    selectedLot: q,
    showFilters: b,
    noAdvancedSearch: c,
    isResultPage: d
  }));
};
export default LandForSalePage;